module.exports = __webpack_public_path__ + "img/IMG_8157_L.c7fe5eef.webp";